import script from "./JdSyncCoverItem.vue?vue&type=script&setup=true&lang=js"
export * from "./JdSyncCoverItem.vue?vue&type=script&setup=true&lang=js"

import "./JdSyncCoverItem.vue?vue&type=style&index=0&id=bb35c6bc&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb35c6bc"]])

export default __exports__